"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSTAGRAM_LOGO = exports.TIKTOK_LOGO = exports.OP_HEALTH_LOGO = exports.O_POSITIV_LOGO = exports.AFTERPAY_LOGO = exports.OP_LOGO_GRAY = void 0;
exports.OP_LOGO_GRAY = 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/opositiv-logo-gray.svg?v=1697565946';
exports.AFTERPAY_LOGO = 'https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png';
exports.O_POSITIV_LOGO = 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/op-logo-word.svg?v=1704495731';
exports.OP_HEALTH_LOGO = 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/Main_Logo.svg?v=1746566630';
exports.TIKTOK_LOGO = 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/TT.svg?v=1746129256';
exports.INSTAGRAM_LOGO = 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/IG.svg?v=1746129256';
